// src/App.tsx (完整更新)
import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import { CssBaseline } from '@mui/material';
import { store } from './app/store';
import { useAppSelector, useAppDispatch } from './app/hooks'; // Ensure useAppDispatch is imported
import { fetchUserInfo } from './features/auth/authSlice'; // Import the new thunk
import { lightTheme, darkTheme } from './styles/theme';
import { routes } from './config/routes';
import './i18n'; // Initialize i18n

// We can combine ThemedApp and App for simplicity now
const AppContent: React.FC = () => {
    const dispatch = useAppDispatch();
    const { isAuthenticated } = useAppSelector(state => state.auth);

    // This hook gets the theme mode from our Redux store
    const themeMode = useAppSelector((state) => state.ui.themeMode);

    useEffect(() => {
        // If a token exists, try to fetch the user's full profile
        if (isAuthenticated) {
            dispatch(fetchUserInfo());
        }
    }, [isAuthenticated, dispatch]);

    const theme = themeMode === 'light' ? lightTheme : darkTheme;
    const routing = useRoutes(routes);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {routing}
        </ThemeProvider>
    );
};

const App: React.FC = () => {
    return (
        // Redux Provider must be at the top to provide the store to all components
        <Provider store={store}>
            <AppContent />
        </Provider>
    );
};

export default App;